import { ShortCode } from '@highereducation/wordpress';
import { ListItem } from '@highereducation/hen-ui';

type ListItemShortcodeProps = {
  itemIndex?: number;
  children?: React.ReactNode;
};

export const ListItemShortcode: ShortCode<ListItemShortcodeProps> = {
  balanced: true,
  component: ({ itemIndex, children }) => {
    return <ListItem itemIndex={itemIndex}>{children}</ListItem>;
  },
};
